const content = {
  // Deutsch
  de: {
    hero: {
      title: {
        highlight: "Jede Meinung zählt",
        rest: " – Feedback als wichtiger Baustein für Ihre Zukunft",
      },
      subtitle:
        "Sammle Feedback und verbessere dein Unternehmen mit datengestützten Erkenntnissen.",
      button: "JETZT LOSLEGEN",
      middle: {
        label: "Unser Fokus: Wertvolles Feedback.",
        description:
          "Mit Reebaq optimierst du die Interaktion mit deinen Kunden durch präzise Analysen und leistungsstarke Tools. Von kleinen Start-ups bis hin zu großen Unternehmen – wir helfen dabei, Prozesse zu verbessern und die Kundenbindung zu stärken.",
      },
    },
    feature: {
      card1: {
        title: "Starte mit Reebaq",
        description:
          "Erstelle Feedback-Formulare in wenigen Minuten und teile sie mühelos per QR-Code oder Link. Sammle wertvolle Meinungen, um dein Unternehmen weiterzuentwickeln.",
      },
      card2: {
        title: "Kundenfeedback einfach sammeln",
        description:
          "Ermögliche deinen Kunden unkompliziertes Feedback durch benutzerfreundliche Formulare und sofortige QR-Code-Nutzung. Stärke dein Verständnis für ihre Bedürfnisse.",
      },
      card3: {
        title:
          "VERWANDLE FEEDBACK IN ECHTE ERGEBNISSE – EINFACH UND EFFIZIENT.",
        bulletPoints: [
          "QR-Codes für sofortiges Feedback",
          "Einfaches Teilen von Feedback-Formularen",
          "Direkte Auswertung von Rückmeldungen",
          "Flexible Integration in deine Prozesse",
        ],
        button: "Mehr Erfahren",
      },
    },
    mission: {
      header: {
        title: {
          highlight: "Was Reebaq antreibt",
          rest: " – unsere Mission & Vision",
        },
      },
      missionCard: {
        title: "Unsere Mission: Feedback zugänglich machen",
        description:
          "Wir möchten Unternehmen jeder Größe ermöglichen, wertvolles Kundenfeedback zu sammeln, zu verstehen und effektiv zu nutzen. Unser Ziel ist es, die Brücke zwischen Unternehmen und Kunden zu schlagen – für nachhaltigen Erfolg und bessere Kundenerlebnisse.",
      },
      visionCard: {
        title: "Unsere Vision: Erfolg durch Kundenzentrierung",
        description:
          "Wir glauben, dass der Erfolg eines Unternehmens von der Stimme seiner Kunden abhängt. Mit Reebaq schaffen wir eine Plattform, die Feedback in intelligente Vorteile verwandelt und Unternehmen dabei unterstützt, sich ständig zu verbessern.",
      },
    },
    howItWorks: {
      title: "So funktioniert Reebaq",
      subtitle: " – Einfach, effizient und wirkungsvoll",
      benefits: "Vorteile auf einen Blick:",
      steps: [
        {
          title: "Schritt 1: Feedback sammeln",
          description:
            "Erstelle QR-Codes oder Links für deine Kunden, die sie auf ein intuitives Feedback-Formular leiten.",
        },
        {
          title: "Schritt 2: Feedback analysieren",
          description:
            "Sammle alle Rückmeldungen an einem zentralen Ort und erhalte einen klaren Überblick über die Meinungen.",
        },
        {
          title: "Schritt 3: Kundenbindung stärken",
          description:
            "Nutze das gesammelte Feedback, um die Bedürfnisse deiner Kunden besser zu verstehen.",
        },
      ],
      benefitsList: [
        {
          title: "Zeitsparend",
          description: "Automatisierte Prozesse für eine einfache Handhabung.",
        },
        {
          title: "Kundenfokussiert",
          description:
            "Stelle deine Kunden in den Mittelpunkt und stärke die Bindung.",
        },
        {
          title: "Ergebnisorientiert",
          description: "Verwandle Feedback in konkrete Maßnahmen.",
        },
      ],
    },
    pricing: {
      title: {
        highlight: "Der passende Plan",
        rest: " – für jedes Ziel",
      },
      tiers: [
        {
          title: "Basic",
          price: "19.90",
          description:
            "Ideal für Einzelpersonen oder kleine Teams, die erste Einblicke gewinnen möchten.",
          features: [
            "1 Feedback-Formular",
            "1 QR-Code",
            "Basis-Reports",
            "Ohne Branding",
            "Keine KI-Funktionen",
          ],
        },
        {
          title: "Standard",
          price: "29.90",
          description:
            "Optimales Preis-Leistungs-Verhältnis für wachsende Unternehmen.",
          features: [
            "5 Feedback-Formulare",
            "5 QR-Codes",
            "Eigenes Branding",
            "Detaillierte Analysen",
            "Monatliche KI-Empfehlungen",
          ],
        },
        {
          title: "Premium",
          price: "39.90",
          description:
            "Maximale Flexibilität und intelligente Insights für Profis.",
          features: [
            "10 Feedback-Formulare",
            "10 QR-Codes",
            "Erweiterte KI-Analysen",
            "Eigenes Branding",
            "Monatliche KI-Empfehlungen",
          ],
        },
      ],
      button: "Jetzt starten",
      bestSeller: "Beliebteste Wahl",
    },
    faq: {
      title: "Häufig gestellte Fragen",
      categories: [
        {
          key: "general",
          number: "1",
          title: "Allgemeines über Reebaq",
          description:
            "Erfahre, wie Reebaq Unternehmen dabei hilft, Kundenfeedback effizient zu nutzen.",
          questions: [
            {
              q: "Wie unterstützt Reebaq Unternehmen bei der Verbesserung des Kundenfeedbacks?",
              a: "Reebaq hilft Unternehmen, strukturiertes Feedback über QR-Codes und Online-Formulare zu sammeln und auszuwerten.",
            },
            {
              q: "Welche Branchen profitieren am meisten von Reebaq?",
              a: "Besonders der Einzelhandel, Gastronomie, Dienstleister und Online-Shops profitieren von schnellem Kundenfeedback.",
            },
            {
              q: "Ist Reebaq für kleine und große Unternehmen gleichermaßen geeignet?",
              a: "Ja, Reebaq ist skalierbar und bietet flexible Lösungen für Unternehmen jeder Größe.",
            },
            {
              q: "Wie lange dauert die Einrichtung von Reebaq?",
              a: "Die Einrichtung dauert nur wenige Minuten – einfach registrieren, QR-Code generieren und Feedback sammeln.",
            },
            {
              q: "Welche Erfolgsgeschichten gibt es bereits mit Reebaq?",
              a: "Viele Unternehmen konnten durch gezieltes Feedback ihre Kundenzufriedenheit um über 30% steigern.",
            },
          ],
        },
        {
          key: "features",
          number: "2",
          title: "Funktionen und Features",
          description:
            "Entdecke die Tools, die Feedback sammeln, analysieren und Kundenbindung stärken.",
          questions: [
            {
              q: "Welche Arten von Feedback kann ich mit Reebaq sammeln?",
              a: "Kunden können über QR-Codes, Links und E-Mail-Umfragen Bewertungen und Kommentare abgeben.",
            },
            {
              q: "Gibt es Analyse-Tools, um das Feedback auszuwerten?",
              a: "Ja, es gibt ein Dashboard mit Statistiken, Trends und KI-gestützten Vorschlägen zur Optimierung.",
            },
            {
              q: "Welche Automatisierungsfunktionen bietet Reebaq?",
              a: "Automatische Antworten, Integration in CRM-Systeme und Benachrichtigungen bei neuem Feedback.",
            },
            {
              q: "Kann ich Feedback-Ergebnisse exportieren und teilen?",
              a: "Ja, Reports können als PDF oder CSV exportiert und mit Teams geteilt werden.",
            },
            {
              q: "Gibt es Integrationen mit anderen Tools wie Zapier oder Slack?",
              a: "Ja, Reebaq lässt sich mit Zapier, Slack und anderen Business-Tools verbinden.",
            },
          ],
        },
        {
          key: "security",
          number: "3",
          title: "Datenschutz und Sicherheit",
          description:
            "Erhalte Einblicke in unsere Sicherheitsstandards und Datenschutzrichtlinien.",
          questions: [
            {
              q: "Wie schützt Reebaq die gesammelten Kundendaten?",
              a: "Alle Daten werden verschlüsselt gespeichert und durch moderne Sicherheitsprotokolle geschützt.",
            },
            {
              q: "Erfüllt Reebaq die Anforderungen der DSGVO?",
              a: "Ja, Reebaq entspricht allen europäischen Datenschutzrichtlinien.",
            },
            {
              q: "Wo werden die Feedback-Daten gespeichert?",
              a: "Die Daten werden auf sicheren Servern innerhalb der EU gespeichert.",
            },
            {
              q: "Wer hat Zugriff auf die gesammelten Daten?",
              a: "Nur autorisierte Personen innerhalb des Unternehmens haben Zugriff auf die Daten.",
            },
            {
              q: "Welche Sicherheitsmaßnahmen setzt Reebaq ein, um Datenlecks zu verhindern?",
              a: "Regelmäßige Sicherheitsprüfungen, Zwei-Faktor-Authentifizierung und automatische Backups.",
            },
          ],
        },
        {
          key: "pricing",
          number: "4",
          title: "Preise und Support",
          description:
            "Flexible Preispläne und ein Support-Team, das dir jederzeit zur Seite steht.",
          questions: [
            {
              q: "Welche Preismodelle bietet Reebaq an?",
              a: "Es gibt drei Modelle: Basic, Standard und Premium, je nach Funktionsumfang.",
            },
            {
              q: "Gibt es individuelle Angebote für Großunternehmen?",
              a: "Ja, Unternehmen mit speziellen Anforderungen können individuelle Lösungen erhalten.",
            },
            {
              q: "Bietet Reebaq einen kostenlosen Testzeitraum an?",
              a: "Ja, alle neuen Kunden erhalten eine 14-tägige Testversion ohne Verpflichtungen.",
            },
            {
              q: "Wie erreiche ich den technischen Support von Reebaq?",
              a: "Über den Live-Chat, per E-Mail oder telefonisch während der Geschäftszeiten.",
            },
            {
              q: "Welche Schulungen oder Onboarding-Programme bietet Reebaq für Unternehmen?",
              a: "Wir bieten Webinare, Video-Tutorials und persönliche Onboarding-Sitzungen.",
            },
          ],
        },
      ],
    },
    contact: {
      title: "Kontaktiere uns",
      description:
        "Kontaktiere uns jederzeit. Wir werden uns so schnell wie möglich bei dir melden.",
      form: {
        namePlaceholder: "Name",
        emailPlaceholder: "E-Mail",
        messagePlaceholder: "Nachricht",
        submitButton: "ABSENDEN",
        nameError: "Bitte gib deinen Namen ein!",
        emailError: "Bitte gib deine E-Mail-Adresse ein!",
        emailInvalidError: "Bitte gib eine gültige E-Mail-Adresse ein!",
        messageError: "Bitte gib deine Nachricht ein!",
      },
      infoCard: {
        title: "Kontaktinformationen",
        email: "info@reebaq.de",
        hours: "08:00 - 17:00",
        name: "Reebaq",
      },
    },
    footer: {
      legalItems: [
        { label: "Datenschutz", link: "/privacypolicy" },
        { label: "Impressum", link: "/impressum" },
        { label: "Cookies", link: "/cookies" },
        { label: "AGBs", link: "/agbs" },
      ],
    },
  },
  //ENGLISCH
  en: {
    hero: {
      title: {
        highlight: "Every opinion matters",
        rest: " – Feedback as a key building block for your future",
      },
      subtitle:
        "Collect feedback and improve your business with data-driven insights.",
      button: "GET STARTED NOW",
      middle: {
        label: "Our focus: Valuable feedback.",
        description:
          "With Reebaq, you optimize customer interaction with precise analysis and powerful tools. From startups to large companies – we help improve processes and strengthen customer loyalty.",
      },
    },
    feature: {
      card1: {
        title: "Get started with Reebaq",
        description:
          "Create feedback forms in minutes and share them effortlessly via QR code or link. Collect valuable opinions to advance your business.",
      },
      card2: {
        title: "Easily Collect Customer Feedback",
        description:
          "Allow your customers to provide feedback with user-friendly forms and instant QR code usage. Enhance your understanding of their needs.",
      },
      card3: {
        title: "TURN FEEDBACK INTO REAL RESULTS – SIMPLE & EFFICIENT.",
        bulletPoints: [
          "QR codes for instant feedback",
          "Easy sharing of feedback forms",
          "Direct evaluation of responses",
          "Flexible integration into your processes",
        ],
        button: "Learn More",
      },
    },
    mission: {
      header: {
        title: {
          highlight: "What Drives Reebaq",
          rest: " – our mission & vision",
        },
      },
      missionCard: {
        title: "Our Mission: Making feedback accessible",
        description:
          "We aim to empower businesses of all sizes to collect, understand and effectively utilize valuable customer feedback. Our goal is to bridge the gap between companies and their customers for sustainable success and improved customer experiences.",
      },
      visionCard: {
        title: "Our Vision: Success through customer centricity",
        description:
          "We believe that a company's success depends on the voice of its customers. With Reebaq, we create a platform that turns feedback into intelligent advantages and helps companies continuously improve.",
      },
    },
    howItWorks: {
      title: "How Reebaq Works",
      subtitle: " – Simple, efficient, and impactful",
      benefits: "Key Benefits at a Glance:",
      steps: [
        {
          title: "Step 1: Collect Feedback",
          description:
            "Generate QR codes or links for your customers that direct them to an intuitive feedback form.",
        },
        {
          title: "Step 2: Analyze Feedback",
          description:
            "Gather all responses in one place and gain a clear overview of customer opinions.",
        },
        {
          title: "Step 3: Strengthen Customer Engagement",
          description:
            "Use the collected feedback to better understand your customers' needs.",
        },
      ],
      benefitsList: [
        {
          title: "Time-Saving",
          description: "Automated processes for easy handling.",
        },
        {
          title: "Customer-Centric",
          description: "Put your customers first and strengthen engagement.",
        },
        {
          title: "Result-Oriented",
          description: "Turn feedback into actionable insights.",
        },
      ],
    },
    pricing: {
      title: {
        highlight: "A Plan for Every Goal",
        rest: " – Choose the Right Fit",
      },
      tiers: [
        {
          title: "Basic",
          price: "19.90",
          description:
            "Perfect for individuals or small teams starting to gather insights.",
          features: [
            "1 feedback form",
            "1 QR code",
            "Basic reports",
            "No branding",
            "No AI features",
          ],
        },
        {
          title: "Standard",
          price: "29.90",
          description:
            "The best value for growing businesses looking to scale efficiently.",
          features: [
            "5 feedback forms",
            "5 QR codes",
            "Custom branding",
            "Detailed analytics",
            "Monthly AI recommendations",
          ],
        },
        {
          title: "Premium",
          price: "39.90",
          description:
            "Maximum flexibility and smart insights for professionals.",
          features: [
            "10 feedback forms",
            "10 QR codes",
            "Advanced AI reports",
            "Custom branding",
            "Monthly AI recommendations",
          ],
        },
      ],
      button: "Get Started",
      bestSeller: "Most Popular",
    },
    faq: {
      title: "Frequently Asked Questions",
      categories: [
        {
          key: "general",
          number: "1",
          title: "General Information about Reebaq",
          description:
            "Learn how Reebaq helps businesses utilize customer feedback effectively.",
          questions: [
            {
              q: "How does Reebaq help businesses improve customer feedback?",
              a: "Reebaq enables businesses to collect structured feedback via QR codes and online forms, making it easier to track customer opinions.",
            },
            {
              q: "Which industries benefit the most from Reebaq?",
              a: "Retail, hospitality, service providers, and online businesses benefit from quick and structured customer feedback.",
            },
            {
              q: "Is Reebaq suitable for both small and large businesses?",
              a: "Yes, Reebaq is scalable and designed to support businesses of all sizes with flexible solutions.",
            },
            {
              q: "How long does it take to set up Reebaq?",
              a: "The setup takes just a few minutes – register, generate a QR code, and start collecting feedback instantly.",
            },
            {
              q: "Are there any success stories with Reebaq?",
              a: "Many businesses have successfully improved customer satisfaction by over 30% through targeted feedback collection.",
            },
          ],
        },
        {
          key: "features",
          number: "2",
          title: "Features and Tools",
          description:
            "Discover the tools that help you collect, analyze, and strengthen customer relationships.",
          questions: [
            {
              q: "What types of feedback can I collect with Reebaq?",
              a: "Customers can submit ratings, reviews, and comments via QR codes, shareable links, or email surveys.",
            },
            {
              q: "Does Reebaq offer analysis tools for feedback evaluation?",
              a: "Yes, Reebaq provides a dashboard with real-time statistics, trends, and AI-driven insights for better decision-making.",
            },
            {
              q: "What automation features does Reebaq provide?",
              a: "Automated responses, CRM integrations, and real-time notifications to ensure efficient feedback processing.",
            },
            {
              q: "Can I export and share feedback results?",
              a: "Yes, reports can be exported as PDF or CSV files and shared with team members or stakeholders.",
            },
            {
              q: "Does Reebaq integrate with tools like Zapier or Slack?",
              a: "Yes, Reebaq seamlessly integrates with Zapier, Slack, and various other business productivity tools.",
            },
          ],
        },
        {
          key: "security",
          number: "3",
          title: "Privacy and Security",
          description:
            "Get insights into our security standards and data protection policies.",
          questions: [
            {
              q: "How does Reebaq protect collected customer data?",
              a: "All customer data is securely encrypted and stored using modern security protocols.",
            },
            {
              q: "Does Reebaq comply with GDPR requirements?",
              a: "Yes, Reebaq fully complies with GDPR and other international data protection laws.",
            },
            {
              q: "Where is the feedback data stored?",
              a: "Feedback data is securely hosted on servers within the EU with high-level security compliance.",
            },
            {
              q: "Who has access to the collected data?",
              a: "Only authorized business users can access collected feedback data, ensuring data privacy.",
            },
            {
              q: "What security measures does Reebaq use to prevent data breaches?",
              a: "Reebaq implements regular security audits, two-factor authentication, and automatic data backups to prevent leaks.",
            },
          ],
        },
        {
          key: "pricing",
          number: "4",
          title: "Pricing and Support",
          description:
            "Flexible pricing plans and a support team ready to assist you anytime.",
          questions: [
            {
              q: "What pricing models does Reebaq offer?",
              a: "Reebaq offers three pricing tiers: Basic, Standard, and Premium, tailored to different business needs.",
            },
            {
              q: "Are there custom pricing options for large enterprises?",
              a: "Yes, businesses with specific requirements can receive personalized pricing and features.",
            },
            {
              q: "Does Reebaq offer a free trial?",
              a: "Yes, all new users can access a 14-day free trial with full functionality and no commitment.",
            },
            {
              q: "How can I contact Reebaq's technical support?",
              a: "You can reach support via live chat, email, or phone during business hours.",
            },
            {
              q: "Does Reebaq provide onboarding or training for businesses?",
              a: "Yes, we offer webinars, video tutorials, and personalized onboarding sessions to ensure a smooth setup.",
            },
          ],
        },
      ],
    },
    contact: {
      title: "Contact Us",
      description:
        "Feel free to contact us any time. We will get back to you as soon as we can.",
      form: {
        namePlaceholder: "Name",
        emailPlaceholder: "Email",
        messagePlaceholder: "Message",
        submitButton: "SUBMIT",
        nameError: "Please input your name!",
        emailError: "Please input your email!",
        emailInvalidError: "Please enter a valid email!",
        messageError: "Please input your message!",
      },
      infoCard: {
        title: "About Information",
        email: "info@reebaq.de",
        name: "Reebaq",
        hours: "08:00 - 17:00",
      },
    },
    footer: {
      legalItems: [
        { label: "Privacy Policy", link: "/privacypolicy" },
        { label: "Imprint", link: "/impressum" },
        { label: "Cookies", link: "/cookies" },
        { label: "ToS", link: "/agbs" },
      ],
    },
  },
};

export default content;
